import React from 'react';
import './CalculatorPage.css';

import { PageTitle } from '../../../components';
import { Calculator } from '../../../sections';



const CalculatorPage = () => {

  return (

    <div className='calculator-page'>

      {/* Page Title */}
      <PageTitle title={'Calculator'} page={'Calculator'} />

      {/* Calculator Form */}
      <Calculator />

    </div>

  );

}

export default CalculatorPage;